/**
 * Urutan resmi kategori dokumen kebijakan.
 *
 * Dipakai bersama oleh menu CMS (urutan pilihan pada form) dan halaman publik
 * Kebijakan (urutan kelompok). Ditulis di satu tempat supaya kedua layar tidak
 * pernah berbeda urutan - dan sengaja berupa urutan hierarki peraturan, bukan
 * abjad, sebab itulah urutan yang dikenal pembaca peraturan.
 */
export const URUTAN_KATEGORI_DOKUMEN = [
  "Undang-Undang",
  "Peraturan Pemerintah",
  "Peraturan/Keputusan Presiden",
  "Peraturan/Keputusan Menteri",
  "Surat Edaran/Arahan",
  "Dokumen",
];

/**
 * Urutkan daftar kategori mengikuti urutan resmi. Kategori di luar daftar -
 * misalnya yang ditambahkan belakangan lewat menu Category - ditaruh di
 * belakang, tersusun menurut abjad, supaya tidak ada yang hilang dari layar.
 */
export function urutkanKategoriDokumen(daftar = []) {
  // Dua bentuk data dipakai di aplikasi: {name} dari rute kategori biasa dan
  // {label,value} dari rute select. Keduanya diterima supaya pemanggil tidak
  // perlu memetakan ulang isinya.
  const namaKategori = (item) => item?.name ?? item?.label ?? "";

  const peringkat = (nama) => {
    const posisi = URUTAN_KATEGORI_DOKUMEN.indexOf(nama);
    return posisi === -1 ? URUTAN_KATEGORI_DOKUMEN.length : posisi;
  };

  return [...daftar].sort((a, b) => {
    const selisih = peringkat(namaKategori(a)) - peringkat(namaKategori(b));
    return selisih !== 0 ? selisih : namaKategori(a).localeCompare(namaKategori(b));
  });
}
